import { observer } from 'mobx-react';
import { useStore } from 'app/context';
import { Modal } from 'app/components/Modal';
import { runInAction } from 'mobx';

interface ScopeData {
	scope: string;
	start?: number;
	end?: number;
}

interface FitnessTrackerScopesModalProps {
	modalId: string;
	entityScopes: { [key: string]: ScopeData };
}

export const FitnessTrackerScopesModal = observer((props: FitnessTrackerScopesModalProps) => {
	const { uiStore } = useStore();

	return (
		<Modal modalId={props.modalId} title="Datenstand" size="large">
			<div className="scopes-modal-content">
				<table className="table">
					<thead>
						<tr>
							<th>Datenquelle</th>
							<th>Scope</th>
							<th>Von</th>
							<th>Bis</th>
						</tr>
					</thead>
					<tbody>
						{Object.entries(props.entityScopes).map(([key, scopeData]: [string, ScopeData]) => {
							return (
								<tr key={key}>
									<td>{key}</td>
									<td>
										<span className="scope-type">{scopeData.scope}</span>
									</td>
									<td>{scopeData.start || '-'}</td>
									<td>{scopeData.end || '-'}</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</div>
		</Modal>
	);
});
